import type { IContinueWatchingCardFormat } from '$/continue-watching/index.h'
import { getLeftTimeString, getProgress, getViewedTimeString } from '@/tools'
import type { IContinueWatchingCard } from '@setplex/tria-api'
import { MediaTypes } from '@setplex/tria-api'
import type { TFunction } from 'i18next'

const getShowDescription = ({
  seasonNumber,
  episodeNumber,
  t,
}: {
  t: TFunction
  seasonNumber?: string
  episodeNumber?: string
}): string => {
  let subtitleTranslation = ''

  if (episodeNumber)
    subtitleTranslation = t('episode_shortened', {
      number: episodeNumber,
    })

  if (seasonNumber && episodeNumber)
    subtitleTranslation = t('season_episode_shortened', {
      episode_number: episodeNumber,
      season_number: seasonNumber,
    })

  return subtitleTranslation
}

export const formatContinueWatching = ({
  content,
  t,
}: {
  content: IContinueWatchingCard[]
  t: TFunction
}): IContinueWatchingCardFormat[] => {
  return content.map((item) => formatContinueWatchingItem(item, t))
}

export const formatContinueWatchingItem = (
  {
    duration,
    stoppedTime,
    contentType,
    seasonNumber,
    episodeNumber,
    ...rest
  }: IContinueWatchingCard,
  t: TFunction
) => ({
  ...rest,
  duration,
  stoppedTime,
  contentType,
  description:
    contentType === MediaTypes.VOD
      ? undefined
      : getShowDescription({ seasonNumber, episodeNumber, t }),
  progress: getProgress({ duration, stoppedTime }),
  timeLeft: getLeftTimeString({ duration, stoppedTime, t }),
  viewedTime: getViewedTimeString(stoppedTime),
})
